import { render, staticRenderFns } from "./PrinterListItemSimpleCard.vue?vue&type=template&id=5a990f6a&scoped=true"
import script from "./PrinterListItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./PrinterListItemSimpleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a990f6a",
  null
  
)

export default component.exports